module.exports = __webpack_public_path__ + "static/media/comedian_kate_quigley.52f3eac7.png";